import React from 'react'
import { storiesOf } from '@storybook/react'

import QuizChoices from 'components/QuizChoices'

import { IQuizAnswer } from 'protos'

const fakeAnswers: IQuizAnswer[] = [
  { answerId: 'answer-1', shortText: '1' },
  { answerId: 'answer-2', shortText: 'X' },
  { answerId: 'answer-3', shortText: '2' },
]

storiesOf('QuizChoices', module)
  .add('default', () => (
    <QuizChoices
      answers={fakeAnswers}
    />
  ))
  .add('right answer', () => (
    <QuizChoices
      readOnly
      selectedAnswerId="answer-3"
      selectedColor="primary"
      answers={fakeAnswers}
    />
  ))
  .add('wrong answer', () => (
    <QuizChoices
      readOnly
      selectedAnswerId="answer-2"
      selectedColor="error"
      answers={fakeAnswers}
    />
  ))
